<div class="flex flex-col gap-2 items-center justify-center">
  <mat-spinner [diameter]="18"></mat-spinner>
  <div>{{ 'RESULT.LOADING.INIT' | translate }}</div>
</div>
